export const FORSUBMIT = {
  REQUEST: 'Users/ForSubmit/Request',
  SUCCESS: 'Users/ForSubmit/Success',
  FAILURE: 'Users/ForSubmit/Failure'
};

export const GET = {
  REQUEST: 'Users/Get/Request',
  SUCCESS: 'Users/Get/Success',
  FAILURE: 'Users/Get/Failure'
};

export const CREATE = {
  REQUEST: 'Users/Create/Request',
  SUCCESS: 'Users/Create/Success',
  FAILURE: 'Users/Create/Failure'
};

export const PATCHPARTY = {
  REQUEST: 'Users/PatchParty/Request',
  SUCCESS: 'Users/PatchParty/Success',
  FAILURE: 'Users/PatchParty/Failure'
};

export const UPDATE = {
  REQUEST: 'Users/Update/Request',
  SUCCESS: 'Users/Update/Success',
  FAILURE: 'Users/Update/Failure'
};

export const CLEAR = {
  REQUEST: 'Users/Clear/Request',
  SUCCESS: 'Users/Clear/Success',
  FAILURE: 'Users/Clear/Failure'
};

export const CHANGEPASSWORD = {
  REQUEST: 'Users/ChangePassword/Request',
  SUCCESS: 'Users/ChangePassword/Success',
  FAILURE: 'Users/ChangePassword/Failure'
};

export const RESENDRESETPASSWORD = {
  REQUEST: 'Users/ResendResetPassword/Request',
  SUCCESS: 'Users/ResendResetPassword/Success',
  FAILURE: 'Users/ResendResetPassword/Failure'
};

export const CHANGELOCKSTATUS = {
  REQUEST: 'Users/ChangeLockStatus/Request',
  SUCCESS: 'Users/ChangeLockStatus/Success',
  FAILURE: 'Users/ChangeLockStatus/Failure'
};

export const SOFTDELETEUSER = {
  REQUEST: 'Users/SoftDelete/Request',
  SUCCESS: 'Users/SoftDelete/Success',
  FAILURE: 'Users/SoftDelete/Failure'
};

export const GET_NOTIFICATION_SETTINGS = {
  REQUEST: 'Users/GetNotificationSettings/Request',
  SUCCESS: 'Users/GetNotificationSettings/Success',
  FAILURE: 'Users/GetNotificationSettings/Failure'
};

export const UPDATE_NOTIFICATION_SETTINGS = {
  REQUEST: 'Users/UpdateNotificationSettings/Request',
  SUCCESS: 'Users/UpdateNotificationSettings/Success',
  FAILURE: 'Users/UpdateNotificationSettings/Failure'
};

export const UPDATE_PERIODIC_INFO = {
  REQUEST: 'Users/UpdatePeriodicInfo/Request',
  SUCCESS: 'Users/UpdatePeriodicInfo/Success',
  FAILURE: 'Users/UpdatePeriodicInfo/Failure'
};

export const GET_CURRENT = {
  REQUEST: 'Users/GetCurrent/Request',
  SUCCESS: 'Users/GetCurrent/Success',
  FAILURE: 'Users/GetCurrent/Failure'
};

export const GET_RESPONSIBILITIES = {
  REQUEST: 'Users/GetResponsibilities/Request',
  SUCCESS: 'Users/GetResponsibilities/Success',
  FAILURE: 'Users/GetResponsibilities/Failure'
};
